const resolveApiBaseUrl = () => {
  // Use environment variable if provided (best for docker or specific build targets)
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl && envUrl.trim() && !envUrl.includes('localhost:5000')) {
    return envUrl.replace(/\/+$/, '');
  }

  // In production, we want to use the same domain/IP that serves the frontend
  // Nginx will then proxy /api requests to the backend
  if (typeof window !== 'undefined' && window.location) {
    const { hostname, origin } = window.location;

    // If we are on localhost, but NOT in a build environment that forced a URL
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:5005/api'; //'http://localhost:5005/api';
    }

    // On AWS EC2 or any other server, use the origin + /api
    return `${origin.replace(/\/+$/, '')}/api`;
  }

  return 'http://localhost:5005/api'; //'http://localhost:5005/api';
};

export const API_BASE_URL = resolveApiBaseUrl();

export const buildApiUrl = (path = '') => {
  if (!path) {
    return API_BASE_URL;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

